import React from 'react';

function ShieldVarification(props: object) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.615 2.0432L5.04083 3.76654C3.98667 4.1607 3.125 5.40737 3.125 6.5257V13.3365C3.125 14.4182 3.84 15.839 4.71083 16.4899L8.6525 19.4324C9.945 20.404 12.0717 20.404 13.3642 19.4324L17.3058 16.4899C18.1767 15.839 18.8917 14.4182 18.8917 13.3365V6.5257C18.8917 5.3982 18.03 4.15154 16.9758 3.75737L12.4017 2.0432C11.6225 1.75904 10.3758 1.75904 9.615 2.0432Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M1.29688 3.8799L2.77271 5.35573L6.71437 1.41406"
          stroke="#000"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </path>
    </svg>
  );
}

export default ShieldVarification;
